export default {
    chatData: {
        caseId: null,
        chatId: null,
        clientId: null,
        deviceId: null,
        taggingMessageId: null,
        searchMessageId: null,
    },

    isTagging: false,
    isLoading: false,
    currentRoute: '',
    chatPage: 1,
    chatSize: 10,
    keySearch: '',
    hasMoreMessages: false,

    countReminders: null,
};